import {connect} from "react-redux";
import CarServiceActivityList from "./List";
import {bindActionCreators} from "redux";
import {activityList} from "../../../../service/Activity/action";
import {isCheckout, markAttendance, saveAccount, lastCheckIn} from "../../../../service/CarService/action";
import {documentUploadUrlPublic} from "../../../../service/fileUpload/action";
import {ratingSave} from "../../../../service/Dealer/action";
import {errorLogs} from "../../../../service/FasttagToll/action";

const mapStateToProps = (state) => ({
    activityListDetails: state.Activity.activityList,
    isCheckoutDetails:state.CarService.isCheckout,
    lastCheckInRes:state.CarService.lastCheckInRes,
    attendance:state.CarService.attendance,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    savedRating: state.Dealer.savedRating,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            activityList,
            isCheckout,
            markAttendance,
            documentUploadUrlPublic,
            lastCheckIn,
            ratingSave,
            errorLogs
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(CarServiceActivityList);
